import React, { useState } from 'react';
import { Typography, TextField, Button, Card, Box, Container } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo0.png';
import backgroundLogin from '../assets/backgroundlogin.png';

const UpdatePassword = () => {
  const { updatePassword } = useAuth();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      return setError('Passwords do not match');
    }

    try {
      await updatePassword(newPassword);
      setMessage('Password has been updated successfully');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.message || 'Failed to update password');
    }
  };

  return (
    <Box sx={{ 
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      backgroundImage: `url(${backgroundLogin})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }}>
      {/* Header */}
      <Box sx={{
        width: '100%',
        backgroundColor: '#000000',
        padding: '20px 0',
        marginBottom: '20px'
      }}>
        <Container maxWidth="lg" sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Box
            component="img"
            src={logo}
            alt="Larrivarie's Logo"
            sx={{
              height: 'auto',
              width: '150px',
              filter: 'brightness(0) invert(1)',
              objectFit: 'contain'
            }}
          />
        </Container>
      </Box>

      {/* Main Content */}
      <Container sx={{
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '40px 20px'
      }}>
        <Card sx={{
          padding: '40px',
          maxWidth: '450px',
          width: '100%',
          backgroundColor: 'white',
          borderRadius: '4px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
        }}>
          <Typography variant="h6" sx={{ marginBottom: '30px' }}>
            Update Password
          </Typography>

          {message && (
            <Typography color="success.main" sx={{ marginBottom: '16px' }}>
              {message}
            </Typography>
          )}
          {error && (
            <Typography color="error" sx={{ marginBottom: '16px' }}>
              {error}
            </Typography>
          )}

          <form onSubmit={handleSubmit}>
            <TextField
              label="New Password"
              type="password"
              fullWidth
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              margin="normal"
              required
            />
            <TextField
              label="Confirm New Password"
              type="password"
              fullWidth
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              margin="normal"
              required
            />
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{
                mt: 3,
                mb: 2,
                backgroundColor: '#008744',
                '&:hover': {
                  backgroundColor: '#006633'
                }
              }}
            >
              Update Password
            </Button>
          </form>
        </Card>
      </Container>

      {/* Footer */}
      <Box sx={{
        backgroundColor: '#2d2d2d',
        color: '#fff',
        padding: '40px 0'
      }}>
        {/* ... Same footer as ForgotPassword component ... */}
      </Box>
    </Box>
  );
};

export default UpdatePassword; 